import { render, staticRenderFns } from "./TargetCompanies.vue?vue&type=template&id=89207e9c"
import script from "./TargetCompanies.vue?vue&type=script&lang=js"
export * from "./TargetCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports